<template>
  <div class="route-header blurred"  v-if="$route.path !== '/'">
    <route-header-basket v-if="$route.path == '/basket'"></route-header-basket>
    
    <div class="route-header__container" v-else>
      <blue-printing-level></blue-printing-level>
      <div class="route-header__info">
        <div class="route-header__icon" :class="{'icon-document_library-white': $route.path.indexOf('document') !== -1 || $route.path.indexOf('products') !== -1, 'icon-search-white': $route.path.indexOf('search') !== -1, 'icon-image_library-white': $route.path.indexOf('images') !== -1}"></div>
        <h1>{{{header.title}}}</h1>
        <p>{{{header.intro}}}</p>
      </div>
    </div>
  </div>
  <div class="route-header" v-else>
    <div class="route-header__container">
      <header class="shape-header">
        <h1>Welcome to Chameleon</h1>
        <p>Adapt to your Sales Communication needs.</p>
      </header>
    </div>
  </div>
</template>

<script>
import { getResource } from "../vuex/helpers";
import BluePrintingLevel from "./bpl/BluePrintingLevel";
import RouteHeaderBasket from "./RouteHeaderBasket";

export default {
  vuex: {
    getters: {
      header: state => state.header
    },
    actions: { getResource }
  },
  components: { BluePrintingLevel, RouteHeaderBasket }
};
</script>

<style lang="scss">
  @import '../assets/scss/variables.scss';
  @import '../assets/scss/mixins.scss';
  
  .route-header{
    padding: 72px 0px 1px;
    background: url(../assets/img/chameleon_big.jpg) no-repeat top right;
    background-size: cover;
    box-sizing: border-box;

    &.blurred{
      background-image: url(../assets/img/chameleon_blurred.jpg);
    }

    &__container{
      @include clear-fix;
      width: 100%;
      margin: 0px auto;
      max-width: 1120px;
    }

    &__info{
      float: left;
      padding: 48px;
      color: $white;
      width: 760px;
      box-sizing: border-box;

      h1{
        font-weight: normal;
        font-size: 52px;
        margin: 27px 0;
      }
    }

    &__icon{
      width: 64px;
      height: 64px;
    }


    &__helper{
      background: rgba(0,0,0,0.5);
      width: 300px;
      float: left;
      color: $white;
      padding: 38px 30px 30px;
      line-height: 1.5em;

      h3{
        margin: 0;
        font-size: 16px;
        font-weight: normal;
      }

      p{
        margin-top: 0;
        color: $green_light;
      }

      &__select{
        width: 100%;
        margin-bottom: 10px;
      }

      &__button{
        margin-top: 20px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// RouteHeader.vue?5c1fa872